import { render, staticRenderFns } from "./ScreeningResultItem.vue?vue&type=template&id=41a50ddf"
import script from "./ScreeningResultItem.vue?vue&type=script&lang=js"
export * from "./ScreeningResultItem.vue?vue&type=script&lang=js"
import style0 from "./ScreeningResultItem.vue?vue&type=style&index=0&id=41a50ddf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports